import React from 'react'
import {contentCard} from './types'
import {Button} from '@/components/cta'
import {overlayPositionClasses} from './utils'

const ContentCard = (props: contentCard) => {
    const backgroundType = props.backgroundImageType || 'color'
    const urlLink = props.external
        ? props.external_link?.value?.data?.url ?? '#'
        : props.link?.value?.data?.url ?? '#'

    const bgStyle: React.CSSProperties = {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        backgroundImage: backgroundType === 'image' ? `url(${props.backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: backgroundType === 'color' ? props.backgroundColor : 'transparent'
    }

    const overlayPositionClass =
        overlayPositionClasses[props.overlayImagePosition || 'center'] ||
        overlayPositionClasses.center

    return (
        <div className="contentCard-container flex flex-col gap-0 w-[170px] h-[248px] sm:h-[319px] sm:w-[190px] md:w-[230px] lg:h-[528px] lg:w-[315px] xl:w-[396px]">
            <div className="contentCard-backgroundImage w-full h-full relative" style={bgStyle}>
                {props.overlayImage && (
                    <img
                        src={props.overlayImage}
                        alt="Overlay"
                        className={`absolute max-h-[50px] max-w-[64px] lg:max-w-[150px] object-contain ${overlayPositionClass}`}
                    />
                )}
            </div>
            <Button
                clickFunction="none"
                className="contentCard-cta text-[18px] h-[48px] flex justify-center items-center w-full bg-blue-900 text-white lg:h-[60px] lg:text-[24px]"
                url={urlLink}
            >
                {props.ctaText || 'Learn More'}
            </Button>
        </div>
    )
}
export {ContentCard as Card}
